export default __webpack_public_path__ + "static/media/avatar_1.7d604003.svg";